const messages = {
  title: "Innboks",
  desc: "Her finner du viktige varsler og nyheter.",
  newMessages: "Nye meldinger i innboksen",
  link: "Vis meldinger",
  showMessages: "Vis meldinger",
  message: {
    sender: "Avsender",
    thread: "Emne",
    date: "Dato",
  },
  sender: {
    system: "BRIDGESTONE PLUS",
    admin: "Admin",
  },
  back: "Attende",
  time: {
    secondsAgo: "{time} sekunder siden",
    minutesAgo: "{time} minutter siden",
    hoursAgo: "{time} timer siden",
    daysAgo: "{time} dager siden",
  },
};
export default {
  messages,
};
